import { render, staticRenderFns } from "./FadeAway.vue?vue&type=template&id=0b58eaaa&scoped=true&"
import script from "./FadeAway.vue?vue&type=script&lang=js&"
export * from "./FadeAway.vue?vue&type=script&lang=js&"
import style0 from "./FadeAway.vue?vue&type=style&index=0&id=0b58eaaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58eaaa",
  null
  
)

export default component.exports